import { useMutation } from "react-query";
import useSignup from "../../common/hooks/pages/useSignup";
import SignupForm from "../components/SignupForm";
import { usePopup } from "../../common/contexts/PopupContext";

function SignupContainer() {
  const { signup } = useSignup();

  const { toast } = usePopup();

  const { mutate, isLoading } = useMutation({
    mutationFn: signup,
    onSuccess: (res) => {
      toast(res?.data?.message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message || "Something went wrong while sign up!";
      toast(message, "error");
    },
  });

  return (
    <SignupForm onSubmit={(data) => mutate(data)} isSubmitting={isLoading} />
  );
}

export default SignupContainer;
